import React from 'react';
import { Link } from 'react-router-dom';
import ProgramsSectionTitle from './ProgramsSectionTitle';

const items = [
  {
    id: 1,
    title: 'AI Prototype for Public Sector',
    info: 'The goal of the project is to build a prototype of an AI-based tool that can be used by public sector organizations to predict service needs based on client characteristics and results.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Public Sector',
    image: 'project-details/public_sector_AI_v2_thumbnail.webp',
    link: '/programs/work-integrated-learning/ai-prototype-for-public-sector'
  },
  {
    id: 2,
    title: 'Artificial intelligence for speech enhancement',
    info: 'This project aims to use data collection with field work to create a model to improve the performance of RMK mics, a device used to receive and deliver sound.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Assistive Tech & Accessibility',
    image: 'project-details/AI_speech_enhancement_v2_thumbnail.webp',
    link: '/programs/work-integrated-learning/artificial-intelligence-for-speech-enhancement'
  },
  {
    id: 3,
    title: 'Convert Chat Threads into a Vector Database',
    info: 'The goal of this project is to apply the latest AI & ML techniques to an existing dataset to create an AI/ML model that supports development of more content and user access with the platform\'s evolution.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Healthcare',
    image: 'project-details/AIChat_db_thumbnail.webp',
    link: '/programs/work-integrated-learning/convert-chat-threads-into-a-vector-database'
  },
  {
    id: 4,
    title: 'AI & ML for Sports Data Site',
    info: 'Development of an AI / ML model related to projecting player and team performance, or findings other insights in the data so that it can be added to the data directory in SportWise.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Sports Analytics',
    image: 'project-details/AI_sports_data_thumbnail.webp',
    link: '/programs/work-integrated-learning/aritificial-intelligence-and-machine-learning-for-sports-data-site'
  },
  {
    id: 5,
    title: 'Data Analytics Skills Assignments',
    info: 'We are launching an exciting initiative aimed at developing the next generation of data analytics talent in higher education.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Education',
    image: 'project-details/Data_Analytics_skills_thumb.webp',
    link: '/programs/work-integrated-learning/data-analytics-skills-assignments'
  },
  {
    id: 6,
    title: 'Health Sciences Data Analytics',
    info: 'Develop a pilot project to illustrate the role of multi-edge computing in Neuraura\'s long-term vision for LoOoP.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Healthcare',
    image: 'project-details/health_sciences_data_analytics_thumb.webp',
    link: '/programs/work-integrated-learning/health-sciences-data-analytics'
  },
  {
    id: 7,
    title: 'AI for Green Hydrogen Microgrid Optimization',
    info: 'This project explores how artificial intelligence can be applied to optimize the performance and decision-making processes within a green hydrogen microgrid system.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'CleanTech',
    image: 'project-details/hydrogen_microgrid_thumbnail.webp',
    link: '/programs/work-integrated-learning/ai-for-green-hydrogen-microgrid-optimization',
    // form: true,
  },
  {
    id: 8,
    title: 'AI for Pet Nutrition Recommendation',
    info: 'This project explores how artificial intelligence can be applied to enhance pet health and wellness through personalized insights.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Healthcare',
    image: 'project-details/pet_nutrition_thumbnail.webp',
    link: '/programs/work-integrated-learning/ai-for-pet-nutrition-recommendation',
    // form: true,
  },
  {
    id: 9,
    title: 'AI for Real-Time Speech Accessibility',
    info: 'This project investigates how artificial intelligence can support inclusive communication by improving speech recognition systems for individuals with atypical speech patterns.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Healthcare',
    image: 'project-details/real_time_speech_accessibility_thumbnail.webp',
    link: '/programs/work-integrated-learning/ai-for-real-time-speech-accessibility',
    // form: true,
  },
  {
    id: 10,
    title: 'Wildfire Risk Forecasting',
    info: 'This project investigates how artificial intelligence can support environmental sustainability and risk preparedness.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Forestry / CleanTech',
    image: 'project-details/wildfire_thumbnail.webp',
    link: '/programs/work-integrated-learning/wildfire-risk-forecasting',
    // form: true,
  },
  {
    id: 11,
    title: 'Generative RNA Design',
    info: 'This project explores how artificial intelligence can be applied to accelerate scientific discovery in the field of computational biology.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Healthcare',
    image: 'project-details/generative_rna_thumbnail.webp',
    link: '/programs/work-integrated-learning/generative-rna-design',
    // form: true,
  },
  {
    id: 12,
    title: 'Seafood Properties Prediction',
    info: 'This project explores how computer vision and machine learning can be applied to automate quality assessment processes in food and natural resource industries.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Maritime / Food Processing',
    image: 'project-details/seafood_properties_prediction_thumbnail.webp',
    link: '/programs/work-integrated-learning/seafood-properties-prediction',
    // form: true,
  },
  {
    id: 13,
    title: 'Home Energy Data Intelligence',
    info: 'This project explores how artificial intelligence can be used to improve energy efficiency in residential buildings.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Energy',
    image: 'project-details/home_energy_data_intelligence_thumbnail.webp',
    link: '/programs/work-integrated-learning/home-energy-data-intelligence',
    // form: true,
  },
  {
    id: 14,
    title: 'Crop Disease Detection',
    info: 'This project explores how artificial intelligence can be used to support early detection of plant health issues in agricultural settings.',
    numberOfCourses: 'Team collaboration',
    modeOfCourses: 'Anywhere',
    category: 'Agriculture',
    image: 'project-details/crop_disease_detection_thumbnail.webp',
    link: '/programs/work-integrated-learning/crop-disease-detection',
    // form: true,
  }
];

const IndustryPartnerWIL = ( {
  setShowUserInterestForm
  } ) => {
  return (
    <>
      <div className="edu-service-area service-wrapper-1 datatalent-section-gap wil-showcase" id="Work_Integrated_Learning">
        <div className="container eduvibe-animated-shape">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProgramsSectionTitle
                classes="text-white"
                title="WIL Showcase"
              />
            </div>
            { items.map( ( data , i ) => (
              <div key={data.id} className="col-lg-6 col-md-6 col-sm-6 col-12 px-0 px-md-4">
                <div className="service-card program-service-card service-card-1 radius-small">
                  <div className="inner">
                    <div className="thumbnail">
                      <a href={ data.link }>
                        <img src={`${process.env.PUBLIC_URL}/images/${ data.image }`} alt="Category Thumb" loading="lazy" />
                      </a>
                    </div>
                    <div className="content program-info">
                      <div className="program-info-content d-flex justify-content-start">
                        {/* <span className="course-total"><i className="icon-time-line"></i> { data.numberOfCourses }</span> */}
                        <span className="course-total">Industry: <strong>{ data.category }</strong></span>
                      </div>
                      <h6 className="title mt-3"><a href={ data.link }>{ data.title }</a></h6>
                      <p className="description">{ data.info }</p>
                      <div className="d-flex justify-content-between flex-wrap mt-3">
                        {data.form ? <a className="edu-btn btn-secondary mt-3" href="https://form.jotform.com/m2mtech/wil-programs-sign-up">Register Now<i className="icon-arrow-right-line-right"></i></a> : <a href="/" style={{visibility : "hidden"}}>No link</a>}
                        <Link className="edu-btn btn-bg-alt mt-3" to={ data.link }>Find Out More<i className="icon-arrow-right-line-right"></i></Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) ) }
          </div>
        </div>
      </div>
    </>
  )
}

export default IndustryPartnerWIL;